import { isMobile } from './device-utils';

const addFixedBody = () => document.body.classList.add('is-body-fixed');

const removeFixedBody = () => document.body.classList.remove('is-body-fixed');

const enabler = {
  ALL: () => removeFixedBody(),
  MOBILE: () => (isMobile() ? removeFixedBody() : null),
  DESKTOP: () => (!isMobile() ? removeFixedBody() : null),
};

const disabler = {
  ALL: () => addFixedBody(),
  MOBILE: () => (isMobile() ? addFixedBody() : null),
  DESKTOP: () => (!isMobile() ? addFixedBody() : null),
};

/**
 * Allow body-scrolling depending on the device
 * @param {String} breakpoint 'ALL' | 'MOBILE' | 'DESKTOP'
 */
export const allowBodyScroll = (breakpoint = 'ALL') => enabler[breakpoint]();

/**
 * Prevent body-scrolling depending on the device
 * @param {String} breakpoint 'ALL' | 'MOBILE' | 'DESKTOP'
 */
export const preventBodyScroll = (breakpoint = 'ALL') => disabler[breakpoint]();
